export default __webpack_public_path__ + "static/media/icon_unbookmark.22d3a144.svg";